"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextField = void 0;
const EditorFieldBase_1 = require("./EditorFieldBase");
class TextField extends EditorFieldBase_1.EditorFieldBase {
}
exports.TextField = TextField;
